export default __webpack_public_path__ + "static/media/home6.e834e7cc.jpg";